import { render } from "./EmpresaList.vue?vue&type=template&id=5834a142&scoped=true"
import script from "./EmpresaList.vue?vue&type=script&lang=js"
export * from "./EmpresaList.vue?vue&type=script&lang=js"

import "./EmpresaList.vue?vue&type=style&index=0&id=5834a142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5834a142"]])

export default __exports__